import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash/fp';
import { resolveIds } from 'app/store/utils';

const selectSlice = get('notifications');
const selectNotificationsById = createSelector(selectSlice, get('byId'));
const selectUnreadNotificationIds = createSelector(selectSlice, get('unreadIds'));

export const selectUnreadNotifications = createSelector(
    selectNotificationsById,
    selectUnreadNotificationIds,
    resolveIds
);

export const selectNotificationDetailsForId = (state, props) =>
    get(['notifications', 'byId', props.notificationId, 'details'], state);
